import {
  Box,
  Button,
  CircularProgress,
  debounce,
  IconButton,
  InputAdornment,
  ListItem,
  MenuItem,
  Select,
  // ListItemIcon,
  Typography,
  useTheme,
  TextField,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import {
  ChangeEvent,
  FC,
  MouseEvent,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { Controller, useForm } from "react-hook-form";
import { ProcedureContext } from ".";
import {
  CptCodeType,
  ProcedureFormValueType,
  // ProcedureRateType,
  ProcedureType,
  defaultValues,
  prepareProcedurePayload,
} from "./types";
import { useMutation } from "react-query";
import {
  addCptFavourite,
  // getCalculatedAmount,
  // getInvestigationCptRate,
  getPatientShare,
  getRateOfCpt,
} from "../../services";
import { clinicId } from "../../../constants";
import { FormOnChangeEventType } from "../../types";
import usePopup from "../../../hooks/usePopup";
import { useParams } from "react-router-dom";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PercentIcon from "@mui/icons-material/Percent";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { HL7ContexTriggerContex } from "../../../context/HL7MessageTrigger/HL7MessageTriggerProvider";
import { EmrContext } from "../..";
import useActivitySearch from "../hook/useActivitySearch";
import useSaveActivity from "../hook/useSaveActivity";
import CustomDateField from "../CustomDateField";
import dayjs from "dayjs";
import useAuthentication from "@hooks/useAuthentication";
import moment from "moment";

const AddProcedure: FC<{ close?: () => void }> = ({ close }) => {
  const { encounterId, patientId } = useParams();
  const { patientData, page, triggerConsultationStart } = useContext(EmrContext);
  const { user } = useAuthentication();
  const activitySearchUserId =
    Number(user?.userId ?? user?.login_id) || null;
  const { setTrigger, triggerApi } = useContext(HL7ContexTriggerContex);
  const { showSnackbar } = usePopup();
  const theme = useTheme();
  const fromVerification = Boolean(page == "verification");
  const { CustomModal } = usePopup();
  const { edit, setEdit, refetch } = useContext(ProcedureContext);
  const [checkboxStatus, setCheckboxStatus] = useState<{
    exclude: boolean;
    approval: boolean;
  }>({
    exclude: false,
    approval: false,
  });
  const [isManualCoverage, setIsManualCoverage] = useState<number>(0);
  // const [rateDetails, setRateDetails] = useState<ProcedureRateType>({
  //   approvalRequired: null,
  //   cptGroupID: null,
  //   cptId: null,
  //   cptName: null,
  //   insRate: null,
  //   isExcluded: null,
  // });
  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    reset,
    watch,
    // setError,
    clearErrors,
    // formState: { errors }
  } = useForm<ProcedureFormValueType>({
    defaultValues,
  });
  const currentValue = watch();
  const selectedCpt = watch("cpt_code");
  const procedureStatus = watch("procedureStatus");

  const {
    mutate: fetchCptCode,
    data: cptCodes,
    isLoading: cptCodeLaoding,
  } = useActivitySearch();
  const [favoriteCptIds, setFavoriteCptIds] = useState<Set<number>>(new Set());
  const [unfavoriteCptIds, setUnfavoriteCptIds] = useState<Set<number>>(new Set());
  const [cptListOpen, setCptListOpen] = useState(false);
  const [show, setShow] = useState<boolean>(false);
  const insDiscount = useRef(0);
  const { mutate: fetchPatientShare, isLoading: fetchPatientShareLoading } =
    useMutation(getPatientShare, {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          insDiscount.current = Number(result.response?.insDiscount || 0);
          const discountType = getValues("discountType") || "Percentage";
          let discount = Number(getValues("discount") || "0");
          let patShare = Number(result.response?.patShare || "0");

          if (discount < 0) {
            discount = 0;
            setValue("discount", 0);
          } else if (discountType === "Percentage" && discount > 100) {
            discount = 100;
            setValue("discount", 100);
          } else if (discountType === "Amount" && patShare > 0 && discount > patShare) {
            discount = patShare;
            setValue("discount", patShare);
          }
          clearErrors("discount");

          if (discountType == "Percentage") {
            patShare = patShare - (patShare * discount) / 100;
          } else {
            patShare = patShare - discount;
            patShare = patShare < 0 ? 0 : patShare;
          }
          setValue("amount", result?.response?.insAmount.toString() || "0");
          setValue("pShare", patShare.toString() || "0");
        }
      },
    });

  const { mutate: saveProcedure, isLoading: procedureLoading } =
    useSaveActivity({
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          setCheckboxStatus({
            approval: false,
            exclude: false,
          });
          showSnackbar({
            message: "Successfully added !",
            open: true,
            variant: "success",
          });
          reset(defaultValues);
          refetch();
          fetchCptCode({
            encounterId: parseInt(encounterId as string),
            poID: patientData?.postOffice?.postofficeId,
            searchText: "",
            groupId: 4,
            userId: activitySearchUserId,
            codetype: String(user?.codetype),
            insname: patientData?.insurancePatient?.insurance_name
              ? String(patientData?.insurancePatient?.insurance_name || "")
              : null,
          });
          setEdit(null);
          triggerConsultationStart();
          triggerApi();
        } else {
          showSnackbar({
            message: "Failed !",
            open: true,
            variant: "warning",
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong !",
          open: true,
          variant: "warning",
        });
      },
    });

  const { mutate: fetchRate, isLoading: fetchRateLoading } = useMutation(
    getRateOfCpt,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success" && result.response) {
          if (result?.response?.insRate != null) {
            setValue("rate", `${result?.response?.insRate || "0"}`);
          } else {
            setValue("rate", "");
            showSnackbar({
              message: "Something went wrong !",
              open: true,
              variant: "warning",
              duration: 2000,
            });
          }
        } else {
          setValue("rate", "");
          showSnackbar({
            message: "Something went wrong !",
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
    },
  );

  const calculatePatientShare = (params: {
    amount: number;
    cptId: number;
    qty: number;
    cptGroupId: number;
  }) => {
    if (Boolean(edit)) {
      fetchPatientShare({
        ...params,
        encounter: parseInt(encounterId as string),
        editFlag: 1,
        id: edit?.procedureId as number,
      });
    } else {
      fetchPatientShare({
        ...params,
        encounter: parseInt(encounterId as string),
        editFlag: 0,
        id: 0,
      });
    }
  };

  const calculateQuandity = () => {
    const rate = Number(getValues("rate") || "0");
    const excluded = getValues("isExcluded");
    const quantity = Number(getValues("quantity") || "0");
    const cpt = getValues("cpt_code");
    let discount = Number(getValues("discount") || "0");
    const discountType = getValues("discountType") || "Percentage";
    let amount = rate * quantity;
    const originalAmount = amount;

    if (discount < 0) {
      discount = 0;
      setValue("discount", 0);
    } else if (discountType === "Percentage" && discount > 100) {
      discount = 100;
      setValue("discount", 100);
    } else if (discountType === "Amount" && amount > 0 && discount > amount) {
      discount = amount;
      setValue("discount", amount);
    }
    clearErrors("discount");

    if (discountType == "Percentage") {
      amount = amount - (amount * discount / 100);
    } else {
      amount = amount - discount;
      amount = amount < 0 ? 0 : amount;
    }
    if (patientData?.pmaster?.paymentMode == 0) {
      setValue("amount", originalAmount.toFixed(2));
      setValue("pShare", amount.toFixed(2));
    } else {
      if (cpt?.insCoverage == 0) {
        setValue("amount", originalAmount.toFixed(2));
        setValue("pShare", amount.toFixed(2));
      } else {
        if (quantity && !excluded) {
          calculatePatientShare({
            cptId: cpt?.cptId || 0,
            amount: rate,
            cptGroupId: cpt?.cptGroupId || 0,
            qty: quantity,
          });
        } else {
          setValue("amount", amount.toFixed(2));
          setValue("pShare", amount.toFixed(2));
        }
      }
    }
  };

  // const cptChange = (e: FormOnChangeEventType) => {
  //   if (Math.floor(e.target.value.cpt_rate) == 0) {
  //     setShow(true);
  //   } else {
  //     // rate:e.target.value.cpt_rate,
  //     setValue("rate", e.target.value.cpt_rate);
  //     resetField("quantity");
  //     resetField("amount");
  //     resetField("pShare");
  //   }
  // };

  const onChange = (e: FormOnChangeEventType) => {
    if (e.target.name == "cpt_code") {
      setValue("isExcluded", e.target.value?.isExclude);
      setValue("isApprovalRequired", e.target.value?.approvalRequired);
      setValue(
        "insuranceCoverage",
        Boolean(
          e?.target?.value?.insCoverage == 1 ||
          e?.target?.value?.insCoverage == 2,
        ),
      );
      setCheckboxStatus({
        approval: !e.target.value?.insCoverage,
        exclude: !e.target.value?.insCoverage,
      });
      if (
        patientData?.pmaster?.paymentMode == 1 &&
        e.target.value.insCoverage == 1 &&
        !e.target.value.isExclude
      ) {
        (isManualCoverage == 1 || e.target.value?.insCoverage == 1) &&
          fetchRate({
            cptId: e.target.value?.cptId as number,
            encounter: parseInt(encounterId as string),
            cptGroupId: e.target.value?.cptGroupId as number,
            paymentMode: 1,
          });
      } else {
        setShow(Boolean(patientData?.pmaster?.paymentMode == 1));
        Boolean(patientData?.pmaster?.paymentMode == 0) &&
          setValue("rate", `${e.target.value.cptRate || "0"}`);
      }
      setValue("quantity", "");
      setValue("amount", "");
      setValue("pShare", "");
      setIsManualCoverage(Number(e.target.value?.insCoverage));
    }

    if (e.target.name == "rate" || e.target.name == "quantity" || e.target.name == "discount" || e.target.name == "discountType") {
      calculateQuandity();
    }

    if (e.target.name == "isPerformed") {
      if (e.target.value) {
        setTrigger({
          encounterId: encounterId as string,
          tab: "procedure",
        });
      }
    }
  };

  const checkBoxChange = (e: FormOnChangeEventType) => {
    if (e.target.name == "isExcluded") {
      const cptDetails = getValues("cpt_code") as CptCodeType;
      setCheckboxStatus({
        approval: e.target.value,
        exclude: false,
      });
      if (cptDetails) {
        if (e.target.value) {
          setShow(true);
        } else {
          reset({
            ...getValues(),
            amount: "",
            quantity: "",
            pShare: "",
            rate: "",
            isExcluded: e.target.value,
            isApprovalRequired: false,
          });
          if (cptDetails?.insCoverage) {
            !fromVerification &&
              isManualCoverage == 1 &&
              fetchRate({
                cptId: cptDetails?.cptId,
                encounter: parseInt(encounterId as string),
                cptGroupId: cptDetails?.cptGroupId as number,
                paymentMode: 1,
              });
            setValue(
              "isApprovalRequired",
              Boolean(cptDetails?.approvalRequired as number),
            );
            setValue(
              "isApprovalRequired",
              Boolean(cptDetails?.approvalRequired as number),
            );
          }
        }
      } else {
        showSnackbar({
          message: "Please select a CPT Code",
          open: true,
          variant: "info",
          duration: 3000,
        });
      }
    } else if (e.target.name == "isApprovalRequired") {
      reset({
        ...getValues(),
        isApprovalRequired: e.target.value,
        isExcluded: false,
      });
      setCheckboxStatus({
        approval: false,
        exclude: e.target.value,
      });
    }
  };

  const handleCashhRate = () => {
    const cptDetails = getValues("cpt_code") as CptCodeType;
    console.log(cptDetails);
    const cptRate = (cptDetails?.cptRate || edit?.cpt_code?.cptRate) as number;
    reset({
      ...getValues(),
      amount: "",
      quantity: "",
      pShare: "",
      rate: cptRate?.toString() || "0",
      isApprovalRequired: false,
    });
    setShow(false);
    setCheckboxStatus({
      approval: getValues("isExcluded")
        ? !!cptDetails?.insCoverage
        : !cptDetails?.insCoverage,
      exclude: !getValues("isExcluded"),
    });
  };

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    fetchCptCode({
      encounterId: parseInt(encounterId as string),
      poID: patientData?.postOffice?.postofficeId,
      searchText: value,
      groupId: 4,
      userId: activitySearchUserId,
      codetype: String(user?.codetype),
      insname: patientData?.insurancePatient?.insurance_name
        ? String(patientData?.insurancePatient?.insurance_name || "")
        : null,
    });
  };

  const debounceSearch = debounce(handleSearch, 500);

  const isCptFavorite = (option: CptCodeType) => {
    if (unfavoriteCptIds.has(option.cptId)) return false;
    if (favoriteCptIds.has(option.cptId)) return true;
    return Number(option.isFavorite) === 1;
  };

  useEffect(() => {
    const favoriteIds =
      cptCodes?.response
        ?.filter((item) => Number(item.isFavorite) === 1)
        .map((item) => item.cptId) ?? [];
    if (!favoriteIds.length) return;
    setFavoriteCptIds((prev) => {
      const next = new Set(prev);
      favoriteIds.forEach((id) => next.add(id));
      return next;
    });
    setUnfavoriteCptIds((prev) => {
      const next = new Set(prev);
      favoriteIds.forEach((id) => next.delete(id));
      return next;
    });
  }, [cptCodes?.response]);

  const { mutate: saveCptFavourite, isLoading: savingCptFavourite } =
    useMutation(addCptFavourite, {
      onSuccess: (result, variables) => {
        if (result.responseIndicator === "success") {
          if (variables.isFavorite === 1) {
            setFavoriteCptIds((prev) => new Set(prev).add(variables.cptId));
            setUnfavoriteCptIds((prev) => {
              const next = new Set(prev);
              next.delete(variables.cptId);
              return next;
            });
          } else {
            setFavoriteCptIds((prev) => {
              const next = new Set(prev);
              next.delete(variables.cptId);
              return next;
            });
            setUnfavoriteCptIds((prev) => new Set(prev).add(variables.cptId));
          }
          setCptListOpen(true);
          showSnackbar({
            message:
              result.responseMessage ||
              (variables.isFavorite === 1
                ? "CPT added to favourites."
                : "CPT removed from favourites."),
            open: true,
            variant: "success",
            duration: 2000,
          });
        } else {
          showSnackbar({
            message: result.responseMessage || "Could not update favourite CPT.",
            open: true,
            variant: "warning",
            duration: 3000,
          });
        }
      },
      onError: (error: { response?: { data?: { responseMessage?: string } } }) => {
        showSnackbar({
          message:
            error?.response?.data?.responseMessage ||
            "Could not update favourite CPT.",
          open: true,
          variant: "error",
          duration: 3000,
        });
      },
    });

  const handleToggleCptFavourite = (
    option: CptCodeType,
    event: MouseEvent<HTMLButtonElement>,
  ) => {
    event.stopPropagation();
    event.preventDefault();
    setCptListOpen(true);
    if (!activitySearchUserId) {
      showSnackbar({
        message: "User id is required to save favourite CPT.",
        open: true,
        variant: "warning",
        duration: 3000,
      });
      return;
    }
    if (savingCptFavourite) return;

    const isFavorite = isCptFavorite(option) ? 0 : 1;
    saveCptFavourite({
      cptId: option.cptId,
      userId: activitySearchUserId,
      clinicId,
      isFavorite,
    });
  };

  const onSubmit = (value: ProcedureFormValueType) => {
    let params: ProcedureType;
    if (value.isPerformed) {
      setTrigger({
        encounterId: encounterId as string,
        tab: "procedure",
      });
    }
    if (Boolean(edit)) {
      params = prepareProcedurePayload({
        ...edit,
        ...value,
        encounterId: encounterId as string,
        patientId: patientId as string,
        paymentMode: patientData?.pmaster?.paymentMode,
        fromVerification,
        insuranceCoverage: Number(isManualCoverage),
      }, insDiscount.current);
    } else {
      params = prepareProcedurePayload({
        ...value,
        encounterId: encounterId as string,
        patientId: patientId as string,
        paymentMode: patientData?.pmaster?.paymentMode,
        fromVerification,
        insuranceCoverage: Number(isManualCoverage),
      }, insDiscount.current);
    }
    // if (fromVerification && Boolean(value.insuranceCoverage && !value.isExcluded)) {
    //   if (
    //     Number(value.rate) * Number(value.quantity) !=
    //     Number(value.amount) + Number(value.pShare)
    //   ) {
    //     showSnackbar({
    //       message: "Sum of Amount and patient share is not match with Rate",
    //       open: true,
    //       variant: "error",
    //     });
    //   } else {
    //     saveProcedure({
    //       fromVerification,
    //       procedureDetailsDto: params,
    //     });
    //   }
    // } else {
    saveProcedure({
      fromVerification,
      procedureDetailsDto: params,
    });
    // }
    console.log("params => ", params);
  };

  const handleClose = () => {
    close && close();
  };

  const handleNoClick = () => {
    setShow(false);
    const cptDetails = getValues("cpt_code") as CptCodeType;
    if (cptDetails?.insCoverage) {
      !fromVerification &&
        isManualCoverage == 1 &&
        fetchRate({
          cptId: cptDetails?.cptId,
          encounter: parseInt(encounterId as string),
          cptGroupId: cptDetails?.cptGroupId as number,
          paymentMode: 1,
        });
    }
    setCheckboxStatus({
      approval: !getValues("isExcluded"),
      exclude: !getValues("isExcluded"),
    });
    setValue("isExcluded", false);
  };

  const handleCloseModal = () => {
    setValue("isExcluded", false);
    const cptDetails = getValues("cpt_code") as CptCodeType;
    setCheckboxStatus({
      approval: !cptDetails?.insCoverage,
      exclude: !cptDetails?.insCoverage,
    });
    setShow(false);
  };
  useEffect(() => {
    fetchCptCode({
      encounterId: parseInt(encounterId as string),
      poID: 1,
      searchText: "",
      groupId: 4,
      userId: activitySearchUserId,
      codetype: String(user?.codetype),
    });
  }, []);

  useEffect(() => {
    setValue("isPerformed", procedureStatus === "COMPLETED");
  }, [procedureStatus, setValue]);

  useEffect(() => {
    if (edit) {
      console.log("edit===>", edit)
      reset({
        ...edit,
        createdDate: edit?.createdDate ? dayjs(edit?.createdDate) : null,
        remarks: edit?.remarks
      });
      setIsManualCoverage(Number(edit?.cpt_code?.insCoverage));
      if (
        patientData?.pmaster?.paymentMode == 1 &&
        edit.cpt_code?.insCoverage == 1 &&
        !edit.isExcluded
      ) {
        Boolean(page != "verification") &&
          !fromVerification &&
          isManualCoverage == 1 &&
          fetchRate({
            cptId: edit.cpt_code?.cptId as number,
            encounter: parseInt(encounterId as string),
            cptGroupId: edit.cpt_code?.cptGroupId as number,
            paymentMode: 1,
          });
      }
    }
  }, [edit]);

  return (
    <div className="border-2 rounded">
      <CustomModal
        handleClose={handleCloseModal}
        open={show}
        setOpen={setShow}
        title="Fetch cash rate"
      >
        <div className="p-2 w-[40vw]">
          <div className="h-[10dvh] p-3">
            <Typography>
              Rate is not defined! Do you want to get the cash Rate
            </Typography>
          </div>
          <div className="flex justify-end gap-2">
            <Button color="error" onClick={handleNoClick}>
              no
            </Button>
            <Button color="success" onClick={handleCashhRate}>
              yes
            </Button>
          </div>
        </div>
      </CustomModal>
      <div className="border-b  rounded-t p-2" style={{}}>
        <Typography color={theme.palette.primary.main} fontWeight={600}>
          {Boolean(edit) ? "Update" : "Add"} Procedures
        </Typography>
      </div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="grid gap-3 grid-cols-8 p-2"
      >
        <div
          className={
            fromVerification
              ? "col-span-full grid grid-cols-12"
              : "col-span-full"
          }
        >
          <div className={fromVerification ? "col-span-10" : ""}>
            <CustomFormField
              name="cpt_code"
              control={control}
              element="autocomplete"
              fieldProps={{ label: "CPT Code", onChange: debounceSearch }}
              rules={{ required: "CPT Code reuired", onChange }}
              options={cptCodes?.response || []}
              loading={cptCodeLaoding}
              autocompleteProps={{
                open: cptListOpen,
                onOpen: () => setCptListOpen(true),
                onClose: () => setCptListOpen(false),
                filterOptions: (option) => option,
                isOptionEqualToValue: (
                  option: CptCodeType,
                  value: CptCodeType,
                ) => option.cptId == value.cptId,
                getOptionLabel: (option: CptCodeType) =>
                  `${option.cptCode} [${option.cptName}]`,
                renderOption: (props, option) => {
                  const { key, ...optionProps } = props;
                  return (
                    <ListItem
                      key={key}
                      {...optionProps}
                      disablePadding
                      sx={{ py: 1, px: 1.5, alignItems: "flex-start" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: 0.5,
                          width: "100%",
                          minWidth: 0,
                        }}
                      >
                        <Box
                          sx={{ flex: 1, minWidth: 0, overflow: "hidden" }}
                        >
                          <div className="grid grid-cols-12 w-full gap-2">
                            <div className="col-span-3 flex items-start justify-start gap-1 min-w-0">
                              <div className="w-5 flex-shrink-0">
                                {option.insCoverage == 1 && (
                                  <VerifiedUserIcon
                                    color="success"
                                    sx={{ fontSize: "1.2rem" }}
                                  />
                                )}
                              </div>
                              <strong
                                style={{ color: theme.palette.text.secondary }}
                              >
                                Code :
                              </strong>{" "}
                              <Typography
                                noWrap
                                sx={{ minWidth: 0 }}
                              >{`${option.cptCode}`}</Typography>
                            </div>
                            <div className="col-span-4 flex gap-1 border-s-2 ps-2 min-w-0">
                              <strong
                                style={{ color: theme.palette.text.secondary }}
                              >
                                Description:
                              </strong>{" "}
                              <Typography
                                noWrap
                                sx={{ minWidth: 0, flex: 1 }}
                              >
                                {option.cptDes}
                              </Typography>
                            </div>
                            <div className="col-span-5 flex gap-1 border-s-2 ps-2 items-center min-w-0">
                              <strong
                                style={{ color: theme.palette.text.secondary }}
                              >
                                Name:
                              </strong>{" "}
                              <Typography noWrap sx={{ minWidth: 0, flex: 1 }}>
                                {option.cptName}
                              </Typography>
                            </div>
                          </div>
                        </Box>
                        <Box sx={{ flexShrink: 0, alignSelf: "center" }}>
                          <IconButton
                            size="small"
                            aria-label={
                              isCptFavorite(option)
                                ? "Remove CPT from favourites"
                                : "Add CPT to favourites"
                            }
                            disabled={savingCptFavourite}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                            onClick={(e) =>
                              handleToggleCptFavourite(option, e)
                            }
                            sx={{ flexShrink: 0, p: 0.5 }}
                          >
                            {isCptFavorite(option) ? (
                              <StarIcon
                                color="warning"
                                sx={{ fontSize: "1.25rem" }}
                              />
                            ) : (
                              <StarBorderIcon sx={{ fontSize: "1.25rem" }} />
                            )}
                          </IconButton>
                        </Box>
                      </Box>
                    </ListItem>
                  );
                },
              }}
            />
          </div>
          <div
            className={
              fromVerification && isManualCoverage == 1
                ? "flex justify-center items-center rounded rounded-s-none border border-s-0 col-span-2"
                : "hidden"
            }
          >
            <VerifiedUserIcon color="success" />
          </div>
          <div
            className={
              Boolean(
                fromVerification &&
                (isManualCoverage == 0 || isManualCoverage == 2),
              )
                ? "flex justify-end rounded rounded-s-none border border-s-0 col-span-2"
                : "hidden"
            }
          >
            <CustomFormField
              name="insuranceCoverage"
              control={control}
              element="checkbox"
              fieldProps={{ label: "Insurance coverage" }}
              checkboxProps={{
                label: "",
                disabled: !Boolean(currentValue?.cpt_code),
              }}
              rules={{
                required: false,
                onChange: (e) => {
                  setValue("pShare", "0");
                  setValue("amount", "0");
                  if (e.target.value) {
                    setValue("cpt_code", {
                      ...(currentValue.cpt_code as CptCodeType),
                      insCoverage: 2,
                    });
                    setCheckboxStatus({
                      approval: false,
                      exclude: false,
                    });
                    setIsManualCoverage(2);
                  } else {
                    setValue("cpt_code", {
                      ...(currentValue.cpt_code as CptCodeType),
                      insCoverage: 0,
                    });
                    setCheckboxStatus({
                      approval: true,
                      exclude: true,
                    });
                    setIsManualCoverage(0);
                  }
                },
              }}
            />
          </div>
        </div>
        <div className="col-span-2">
          <CustomFormField
            name="rate"
            control={control}
            element="input"
            fieldProps={{
              label: "Rate ",
              type: "number",
              InputProps: {
                endAdornment: (
                  <InputAdornment position="end">
                    {fetchRateLoading && <CircularProgress size={18} />}
                  </InputAdornment>
                ),
              },
            }}
            rules={{ required: "Rate required", onChange }}
          />
        </div>
        <div className="col-span-2 grid grid-cols-2 gap-1">
          <CustomFormField
            name="quantity"
            control={control}
            element="input"
            fieldProps={{
              label: "Quantity ",
              type: "number",
              InputProps: {
                endAdornment: (
                  <InputAdornment position="end">
                    {fetchPatientShareLoading && <CircularProgress size={18} />}
                  </InputAdornment>
                ),
              },
            }}
            rules={{ required: "Quantity required", onChange }}
          />
          <div className="flex flex-col">
            <div className="flex">
              <CustomFormField
                control={control}
                element="input"
                name="discount"
                fieldProps={{
                  label: "Discount",
                  type: "number",
                  sx: {
                    fontSize: "0.875rem",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                    },
                    "&.MuiOutlinedInput-root": {
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                    },
                    "& .MuiFormHelperText-root": {
                      display: "none",
                    },
                  },
                  inputProps: { min: 0 },
                  onKeyDown: (e: any) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  },
                  onInput: (e: any) => {
                    let val = Number(e.target.value);
                    const discountType = getValues("discountType") || "Percentage";
                    if (val < 0) {
                      e.target.value = "0";
                    } else if (discountType === "Percentage" && val > 100) {
                      e.target.value = "100";
                    }
                  },
                }}
                rules={{ required: false, onChange }}
              />
              <Controller
                control={control}
                name="discountType"
                rules={{ required: false, onChange }}
                render={({
                  field: { ref, onChange, value = null, ...field },
                }) => (
                  <Select
                    {...field}
                    size="small"
                    value={value}
                    onChange={onChange}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={{
                      fontSize: "0.875rem",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        borderLeft: "none",
                      },
                      "&.MuiOutlinedInput-root": {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        borderLeft: "none",
                      },
                      "& .MuiSelect-select": {
                        paddingX: "4px",
                        borderLeft: "none",
                      },
                    }}
                  >
                    <MenuItem value={"Percentage"}><PercentIcon fontSize="small" /></MenuItem>
                    <MenuItem value={"Amount"}>
                      {/* <AttachMoneyIcon fontSize="small" /> */}
                      AMT.
                    </MenuItem>
                  </Select>
                )}
              />
            </div>
          </div>
        </div>
        <div className="col-span-2">
          <CustomFormField
            name="amount"
            control={control}
            element="input"
            fieldProps={{
              label: "Amount ",
              type: "number",
              // InputProps: { readOnly: true },
            }}
            rules={{ required: "Amount required" }}
          />
        </div>
        <div className="col-span-2">
          <CustomFormField
            name="pShare"
            control={control}
            element="input"
            fieldProps={{ label: "Patient share ", type: "number" }}
            rules={{ required: "Patient share required" }}
          />
        </div>

        <div className="col-span-3">
          <CustomFormField
            name="remarks"
            control={control}
            element="input"
            fieldProps={{ label: "Remarks" }}
            rules={{ required: false }}
          />
        </div>

        <div className="col-span-2">
          <Controller
            control={control}
            name="procedureStatus"
            rules={{ required: "Status required" }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                select
                size="small"
                fullWidth
                label={
                  <span className="text-grey-500">
                    Status <span className="text-red-500">*</span>
                  </span>
                }
                value={field.value || "PLANNED"}
                error={!!error}
                helperText={error?.message || ""}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor:
                      field.value === "COMPLETED"
                        ? "#dcfce7"
                        : field.value === "UNDERGOING"
                          ? "#fef9c3"
                          : "#e0f2fe",
                    transition: "background-color 0.3s ease",
                  },
                }}
              >
                <MenuItem
                  value="PLANNED"
                  sx={{
                    backgroundColor: "#e0f2fe",
                    "&:hover": { backgroundColor: "#bae6fd" },
                  }}
                >
                  PLANNED
                </MenuItem>
                <MenuItem
                  value="UNDERGOING"
                  sx={{
                    backgroundColor: "#fef9c3",
                    "&:hover": { backgroundColor: "#fef08a" },
                  }}
                >
                  UNDERGOING
                </MenuItem>
                <MenuItem
                  value="COMPLETED"
                  sx={{
                    backgroundColor: "#dcfce7",
                    "&:hover": { backgroundColor: "#bbf7d0" },
                  }}
                >
                  COMPLETED
                </MenuItem>
              </TextField>
            )}
          />
        </div>

        <div className="col-span-6 flex gap-2">
          <div className="hidden">
            <CustomFormField
              name="isPerformed"
              control={control}
              element="checkbox"
              fieldProps={{ label: "Already Performed" }}
              rules={{ required: false, onChange }}
            />
          </div>
          <CustomFormField
            name="isExcluded"
            control={control}
            element="checkbox"
            fieldProps={{ label: "Exclude" }}
            rules={{ required: false, onChange: checkBoxChange }}
            checkboxProps={{
              label: "",
              disabled: Boolean(patientData.pmaster.paymentMode)
                ? Boolean(selectedCpt?.insCoverage)
                  ? checkboxStatus.exclude
                  : true
                : true,
            }}
          />

          <CustomFormField
            name="isApprovalRequired"
            control={control}
            element="checkbox"
            fieldProps={{ label: "Approval Required" }}
            rules={{ required: false, onChange: checkBoxChange }}
            checkboxProps={{
              label: "",
              disabled: Boolean(patientData.pmaster.paymentMode)
                ? Boolean(selectedCpt?.insCoverage)
                  ? checkboxStatus.approval
                  : true
                : true,
            }}
          />

          <CustomFormField
            name="nursingProcedure"
            control={control}
            element="checkbox"
            fieldProps={{ label: "Nursing Procedure" }}
            rules={{ required: false }}
          />
        </div>

        <div
          className={
            fromVerification
              ? "col-span-full flex flex-col md:flex-row gap-4 justify-end items-center bg-blue-50/50 p-3 rounded-md mt-2 border border-blue-100"
              : "col-span-full flex flex-col md:flex-row gap-4 justify-end items-center p-3 rounded-md mt-2"
          }
        >
          {fromVerification && (
            <div className="flex gap-3 items-center mr-auto">
              <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded shadow-sm border border-gray-100">
                <span className="text-xs font-semibold text-gray-500 tracking-wider">
                  START TIME:
                </span>
                <span className="text-sm font-medium text-gray-800">
                  {patientData?.encounter?.startTime
                    ? moment(patientData?.encounter?.startTime).format(
                      "DD-MM-YYYY hh:mm A",
                    )
                    : "-"}
                </span>
              </div>
              <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded shadow-sm border border-gray-100">
                <span className="text-xs font-semibold text-gray-500 tracking-wider">
                  END TIME:
                </span>
                <span className="text-sm font-medium text-gray-800">
                  {patientData?.encounter?.endTime
                    ? moment(patientData?.encounter?.endTime).format(
                      "DD-MM-YYYY hh:mm A",
                    )
                    : "-"}
                </span>
              </div>
            </div>
          )}

          <div className="flex justify-end items-center gap-3">
            <div className={fromVerification ? "" : "hidden"}>
              <CustomDateField
                start={patientData?.encounter?.startTime}
                end={patientData?.encounter?.endTime}
                control={control}
                name="createdDate"
              />
            </div>
            <Button
              color="success"
              type="submit"
              disabled={procedureLoading}
              endIcon={
                procedureLoading && (
                  <CircularProgress
                    size={18}
                    sx={(theme) => ({ color: theme.palette.background.paper })}
                  />
                )
              }
            >
              save
            </Button>
            {close && (
              <Button color="error" onClick={handleClose}>
                cancel
              </Button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddProcedure;
